import ListSoldInAppProductsTable from './ListSoldInAppProductsTable';

export default ListSoldInAppProductsTable;
